module.exports = __webpack_public_path__ + "img/1.f93cfc2c.png";